import "../../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from '../generic.view.ts';

import Handlebars from 'handlebars';
import Template from 'text-loader!../../templates/issueTicket/queuesContainer.template.html';
import i18n  from "l10n";

import QueueRowView from './queueRow.view.ts';
import CountdownTimerView from "../helpers/countdownTimer.view.ts";

import PrinterView from "./printer/printer.view.ts";

export default Backbone.View.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
    collection: [],
	initialize: function (options) {
        var self = this;
        this.userData = options.data;

        this.render();

        this.collection = [];
        this.loadData();

        this.printerView = new PrinterView();
	},
	superRender: Backbone.View.prototype.render,
	render: function () {
		this.superRender();

        var templateData = this.template();
		this.$el.html( templateData );
	},
	events:{

	},
	renderItems: function() {
	    var self = this;

        if(this.collection.length == 0)
            return;

        var itemsContainer = $("#queuesContainer");
        itemsContainer.empty();

        $.each(this.collection, function(index, modelData) {

            var optionsData = {
                "model": modelData,
                "printerView": self.printerView
            }

            var queueRowView = new QueueRowView(optionsData);

            itemsContainer.append( queueRowView.render().el );
        });
    },
    loadData: function(selfRef) {
        var self = selfRef ? selfRef : this;

        $.ajaxDefaultQ({
            url: 'rest/api/adminTickets',
            type: 'GET',
        }).done(function(response, status, xhr){
            if(response.data != null && !response.error) {
                self.collection = response.data;

                self.renderItems();

                self.setupCountDownTimer();
            }
            else {
                $.notify(i18n.t("queue.noQueues"), { position:"top center", className: "info"});
            }
        })
        .fail(function(response) {
            console.log("response: ", response);

            if(response.status == 401 || response.status == 403) {
                window.location = "#Login";
            }
        });
    },
    setupCountDownTimer: function() {
        var self = this;

        var dateTo = new Date(new Date().getTime() + (1000 * 30));
        var countdownTimerView = new CountdownTimerView({"dateTo": dateTo, "parentView": self, "callbackFunction": this.loadData});

        this.$el.find("#contentReloadTime").html( countdownTimerView.render().el );
    }
});


